import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import { MultiSelect } from "react-multi-select-component";

const PKVYList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const normalizedPath = (location?.pathname || "").toLowerCase();
    const isSeedDemonstrationRoute =
      normalizedPath === "/newadminpanel/seeddemonstration";

    // Debug current route detection for scheme 15 branching
    useEffect(() => {
      try {
        console.log("[RKVYList] route debug", {
          pathname: location?.pathname,
          stateHeader: location?.state?.header,
          schemeCode,
          isSeedDemonstrationRoute,
        });
      } catch (e) {
        console.log("[RKVYList] route debug error", e);
      }
    }, [normalizedPath, schemeCode, isSeedDemonstrationRoute]);    
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
   
    useEffect(() => {
       // alert(sessionStorage.getItem("schemeCodeModel"));
        getStates();
    }, []);

    useEffect(() => {
    const savedResults = sessionStorage.getItem("searchResults");
    const savedFilters = sessionStorage.getItem("searchFilters");
    const stateCode = sessionStorage.getItem("stateNameModel");
    if (savedResults && savedFilters) {
        setfarmerData(JSON.parse(savedResults));
        const filters = JSON.parse(savedFilters);
        setStateValue(filters.stateValue);
        setDistrictValue(filters.districtValue);
        setsubDistrictValue(filters.subDistrictValue);
        setvillageValue(filters.villageValue);
        setselectedDataSetDistrict(filters.selectedDataSetDistrict);
        setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict);
        setselectedDataSetVillage(filters.selectedDataSetVillage);
    }
}, []);

    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function getStates() {


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions

        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })
                console.log("myArray", myArray)
                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }


    function handleState() {
        setOptionDistrict([]);
        setDistrictValue([]);
        setsubDistrictValue([]);
        setvillageValue([]);

        if (stateValue.length > 1) {
            alert('Please select one value');
            setStateValue([]);
            return false;
        }
        else {
            if (stateValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                let stateValueData = "";

                stateValue.map((item) => {
                    stateValueData = stateValueData + item + ","
                })

                stateValueData = stateValueData.slice(0, -1);
                var raw = JSON.stringify({
                    stateCode: stateValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/district`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataDistrict = JSON.parse(result).dataContent;

                        let myArrayDistrict = [];
                        localFormDataDistrict.map((item, key) => {
                            myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                        })

                        setOptionDistrict(myArrayDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));
            }
        }

    }

    let handleChangeDistrict = (districtValue) => {
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        if (districtValue.length > 1) {
            alert('Please select one value');
            setDistrictValue([]);
            return false;
        }
        else {
            setDistrictValue(districtValue.map(option => option.value));
            setselectedDataSetDistrict(districtValue.map(item => `${item.stateid}|${item.value}`).join(','));

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            if (districtValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                let districtValueData = "";
                districtValue.map((item) => {
                    districtValueData = districtValueData + item.value + ","
                })

                districtValueData = districtValueData.slice(0, -1);


                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/subdistrict`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataSubDistrict = JSON.parse(result).dataContent;

                        let myArraySubDistrict = [];
                        localFormDataSubDistrict.map((item, key) => {
                            myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                        })

                        setOptionSubDistrict(myArraySubDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }
    };

    let handleChangeSubDistrict = (subdistrictValue) => {
        setvillageValue([]);
        setOptionVillage([]);
        if (subdistrictValue.length > 1) {
            alert('Please select one value');
            setsubDistrictValue([]);
            return false;
        }
        else {


            setsubDistrictValue(subdistrictValue.map(option => option.value));
            setselectedDataSetSubDistrict(subdistrictValue.map(item => `${item.districtCode}|${item.value}`).join(','));

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item
            })

            let districtValueData = "";
            districtValue.map((item) => {
                districtValueData = districtValueData + item
            })

            let subdistrictValueData = "";
            subdistrictValue.map((item) => {
                subdistrictValueData = subdistrictValueData + item.value
            })


            if (subdistrictValue.length != 0) {

                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString(),
                    subDistrictCode: subdistrictValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/village`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataVillage = JSON.parse(result).dataContent;

                        let myArrayVillage = [];
                        localFormDataVillage.map((item, key) => {
                            myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                        })

                        setOptionVillage(myArrayVillage)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }


    };



    let handleChange = (stateValue) => {
        console.log("selected State", stateValue);
        setIsFetchingState(false);
        setStateValue(stateValue.map(option => option.value));

    };

    let handleChangeVillage = (villageValue) => {
        if (villageValue.length > 1) {
            alert('Please select one value');
            setvillageValue([]);
            return false;
        }
        else {

            setvillageValue(villageValue.map(option => option.value));
            setselectedDataSetVillage(villageValue.map(item => `${item.subDistrictCode}|${item.value}`).join(','));
        }
    };

    // function formatData(value) {
    //     if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
    //         return value.componentName
    //     }
    //     console.log("value name", value.orgTypeCode);
    //     if (value.orgTypeCode === 1) {
    //         return "Honey Processing Unit"
    //     } else if (value.orgTypeCode === 2) {
    //         return "Honey Testing Unit"
    //     } else if (value.orgTypeCode === 3) {
    //         return "Honey CHC"
    //     } else if (value.orgTypeCode === 4) {
    //         return "Beeflora Plantation"
    //     }
    // }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
      setLoaderFarmer(true);
     
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      console.log("stateValueData", stateCode);
      console.log("districtValueData", districtValueData);
      console.log("subdistrictValueData", subdistrictValueData);
      console.log("villageValueData", villageValueData);

      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
           
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
       
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }



//      const handleExportData = async () => {
//   try {
//     // helper: transform PKVY response -> flat rows with dynamic crop, yield and season columns
//     const transformPKVYResponseToCsvRowsDynamicCropsWithSeason = (dataContent = []) => {
//       // fixed columns before dynamic crop groups
//       const prefixFixedCols = [
//         "finYear",
//         "state",
//         "district",
//         "subdistrict",
//         "village",
//         "farmername",
//         "mobileNo"
//       ];

//       // fixed columns after dynamic crop groups
//       const suffixFixedCols = [
//         "areaCovered_Ha",
//         "totalAreaInHA",
//         "polygonShape",
//         "surveyorLat",
//         "surveyorLong",
//         "SurveyName"
//       ];

//       // determine maximum crops across all rows
//       const maxCrops = (Array.isArray(dataContent) && dataContent.length)
//         ? Math.max(...dataContent.map(r => (Array.isArray(r.crops) ? r.crops.length : 0)))
//         : 0;

//       // build dynamic headers: for each i -> crop_i, yield_i, season_i
//       const dynamicCropCols = [];
//       for (let i = 1; i <= maxCrops; i++) {
//         dynamicCropCols.push(`crop_${i}`);
//         dynamicCropCols.push(`yield_${i}`);
//         dynamicCropCols.push(`season_${i}`);
//       }

//       const headers = [...prefixFixedCols, ...dynamicCropCols, ...suffixFixedCols];

//       const rows = (Array.isArray(dataContent) ? dataContent : []).map(raw => {
//         const row = {};

//         // prefix fields
//         row.finYear = raw.finYear ?? "";
//         row.state = raw.stateName ?? raw.state ?? "";
//         row.district = raw.districtName ?? "";
//         row.subdistrict = raw.subDistrictName ?? raw.subdistName ?? "";
//         row.village = raw.villageName ?? "";
//         row.farmername = raw.farmerName ?? "";
//         row.mobileNo = raw.mobileNo ?? "";

//         // crops array
//         const cropsArr = Array.isArray(raw.crops) ? raw.crops : [];

//         // fill dynamic crop_i, yield_i, season_i
//         for (let i = 1; i <= maxCrops; i++) {
//           const c = cropsArr[i - 1] ?? null;
//           row[`crop_${i}`] = c ? (c.cropName ?? c.cropNameCode ?? "") : "";
//           row[`yield_${i}`] = c ? (c.yield ?? "") : "";
//           row[`season_${i}`] = c ? (c.seasonCode ?? "") : "";
//         }

//         // suffix fields
//         row.areaCovered_Ha = raw.areaCovered_Ha ?? raw.areaCoveredHa ?? "";
//         row.totalAreaInHA = raw.totalAreaInHA ?? "";

//         // polygon: use first polygon if present and try to format
//         const poly = Array.isArray(raw.polygons) && raw.polygons[0] ? raw.polygons[0] : null;
//         if (poly) {
//           const polyShapeRaw = poly.polygonShape ?? poly.polygonshape ?? "";
//           let polyFormatted = "";
//           if (typeof polyShapeRaw === "string") {
//             try {
//               const coords = JSON.parse(polyShapeRaw);
//               if (Array.isArray(coords)) {
//                 polyFormatted = coords.map(p => `${p.lat},${p.lng}`).join(" | ");
//               } else {
//                 polyFormatted = polyShapeRaw;
//               }
//             } catch (e) {
//               polyFormatted = polyShapeRaw;
//             }
//           } else {
//             polyFormatted = String(polyShapeRaw);
//           }
//           row.polygonShape = polyFormatted;
//           row.surveyorLat = poly.surveyorLat ?? "";
//           row.surveyorLong = poly.surveyorLong ?? "";
//         } else {
//           row.polygonShape = "";
//           row.surveyorLat = "";
//           row.surveyorLong = "";
//         }

//         // SurveyName fallback: prefer images[0].createdByUC -> raw.SurveyName -> raw.createdBy -> blank
//         if (raw.SurveyName || raw.surveyName) {
//           row.SurveyName = raw.SurveyName ?? raw.surveyName;
//         } else if (Array.isArray(raw.images) && raw.images[0] && raw.images[0].createdByUC) {
//           row.SurveyName = String(raw.images[0].createdByUC);
//         } else if (raw.createdBy) {
//           row.SurveyName = String(raw.createdBy);
//         } else {
//           row.SurveyName = "";
//         }

//         // ensure all headers exist to keep column order
//         headers.forEach(h => {
//           if (!(h in row)) row[h] = row[h] ?? "";
//         });

//         return row;
//       });

//       return { headers, rows };
//     };

//     // -----------------------
//     // PKVY scheme 22 branch (paginated fetch)
//     // -----------------------
//     // if (sessionStorage.getItem("schemeCodeModel") === "22") {
//     //   setLoaderFarmer(true);

//     //   const baseUrl = process.env.NODE_ENV === 'development'
//     //     ? process.env.REACT_APP_DEV_MODE
//     //     : process.env.REACT_APP_PRO_MODE;

//     //   const userType = sessionStorage.getItem("userTypeCodeModel");
//     //   const storedState = sessionStorage.getItem("stateNameModel");
//     //   const stateCode = userType === "1" ? (stateValue?.[0] ?? 0) : (!storedState || storedState === "null" ? 0 : storedState);
//     //   const schemeCode = sessionStorage.getItem("schemeCodeModel");
//     //   const SurveyUserCode = sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0";
//     //   const districtCode = districtValue?.[0] ?? (sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"));
//     //   const subDistrictCode = subdistrictValue?.[0] ?? (sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"));
//     //   const villageCode = villageValue?.[0] ?? (sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel"));

//     //   const orgTypeCode = sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1;

//     //   let pageNum = 1;
//     //   const pageSize = 1000;
//     //   let allRows = [];

//     //   while (true) {
//     //     const payload = {
//     //       schemeCode,
//     //       orgTypeCode,
//     //       SurveyUserCode,
//     //       stateCode,
//     //       districtCode,
//     //       subDistrictCode,
//     //       PageNumber: pageNum,
//     //       PageSize: pageSize,
//     //       blockCode: 0,
//     //       villageCode,
//     //     };

//     //     const res = await axios.post(`${baseUrl}/api/PKVY/getFarmerDetailsByFilter`, payload);

//     //     const message = res?.data?.message;
//     //     const rows = res?.data?.dataContent || [];

//     //     if (message === "Data Not Found" || !Array.isArray(rows) || rows.length === 0) {
//     //       break;
//     //     }

//     //     allRows = allRows.concat(rows);

//     //     if (rows.length < pageSize) break;
//     //     pageNum += 1;
//     //   }

//     //   setLoaderFarmer(false);

//     //   if (!allRows.length) {
//     //     alert("No data available to export.");
//     //     return;
//     //   }

//     //   const { headers, rows } = transformPKVYResponseToCsvRowsDynamicCropsWithSeason(allRows);

//     //   const csvOptions = {
//     //     fieldSeparator: ",",
//     //     quoteStrings: '"',
//     //     decimalSeparator: ".",
//     //     showLabels: true,
//     //     useBom: true,
//     //     useKeysAsHeaders: false,
//     //     headers,
//     //   };

//     //   const csvExporter = new ExportToCsv(csvOptions);
//     //   csvExporter.generateCsv(rows);
//     //   return;
//     // }

// //     if (sessionStorage.getItem("schemeCodeModel") === "22") {
// //   try {
// //     setLoaderFarmer(true);

// //     const baseUrl = process.env.NODE_ENV === 'development'
// //       ? process.env.REACT_APP_DEV_MODE
// //       : process.env.REACT_APP_PRO_MODE;

// //     const userType = sessionStorage.getItem("userTypeCodeModel");
// //     const storedState = sessionStorage.getItem("stateNameModel");
// //     const schemeCode = sessionStorage.getItem("schemeCodeModel");
// //     const SurveyUserCode = sessionStorage.getItem("userTypeCodeModel") === "5"
// //       ? sessionStorage.getItem("userCodeModel")
// //       : "0";

// //     // ---------- determine single stateCode (priority: selected stateValue[0] when userType==='1', else stored) ----------
// //     let stateSelected = stateValue?.[0] ?? null;
// //     let stateCodeRaw;
// //     if (userType === "1") {
// //       // if userType 1, prefer selected; otherwise fallback to stored
// //       stateCodeRaw = stateSelected ?? (storedState === "null" || !storedState ? 0 : storedState);
// //     } else {
// //       stateCodeRaw = (storedState === "null" || !storedState) ? 0 : storedState;
// //     }
// //     const stateCode = Number.isFinite(Number(stateCodeRaw)) ? Number(stateCodeRaw) : 0;

// //     // ---------- district / subdistrict / village (prefer selected else stored) ----------
// //     const districtSelected = districtValue?.[0] ?? null;
// //     const districtStored = sessionStorage.getItem("districtNameModel");
// //     const districtCode = Number.isFinite(Number(districtSelected ?? (districtStored === "null" || !districtStored ? 0 : districtStored)))
// //       ? Number(districtSelected ?? (districtStored === "null" || !districtStored ? 0 : districtStored))
// //       : 0;

// //     const subDistrictSelected = subdistrictValue?.[0] ?? null;
// //     const subDistrictStored = sessionStorage.getItem("subDistrictNameModel");
// //     const subDistrictCode = Number.isFinite(Number(subDistrictSelected ?? (subDistrictStored === "null" || !subDistrictStored ? 0 : subDistrictStored)))
// //       ? Number(subDistrictSelected ?? (subDistrictStored === "null" || !subDistrictStored ? 0 : subDistrictStored))
// //       : 0;

// //     const villageSelected = villageValue?.[0] ?? null;
// //     const villageStored = sessionStorage.getItem("villageModel");
// //     const villageCode = Number.isFinite(Number(villageSelected ?? (villageStored === "null" || !villageStored ? 0 : villageStored)))
// //       ? Number(villageSelected ?? (villageStored === "null" || !villageStored ? 0 : villageStored))
// //       : 0;

// //     const orgTypeCode = schemeCode === "3" ? 0 : 1;

// //     // ---------- pagination and fetch loop ----------
// //     let pageNum = 1;
// //     const pageSize = 1000;
// //     let allRows = [];

// //     while (true) {
// //       const payload = {
// //         schemeCode,
// //         orgTypeCode,
// //         SurveyUserCode,
// //         stateCode,       // single numeric state code
// //         districtCode,
// //         subDistrictCode,
// //         PageNumber: pageNum,
// //         PageSize: pageSize,
// //         blockCode: 0,
// //         villageCode,
// //       };

// //       // optional debug log — remove in production if not needed
// //       console.log("[DEBUG] PKVY getFarmerDetailsByFilter payload:", payload);

// //       const res = await axios.post(`${baseUrl}/api/PKVY/getFarmerDetailsByFilter`, payload);

// //       const message = res?.data?.message;
// //       const rows = res?.data?.dataContent || [];

// //       if (message === "Data Not Found" || !Array.isArray(rows) || rows.length === 0) {
// //         break;
// //       }

// //       allRows = allRows.concat(rows);

// //       if (rows.length < pageSize) break;
// //       pageNum += 1;
// //     }

// //     setLoaderFarmer(false);

// //     if (!allRows.length) {
// //       alert("No data available to export.");
// //       return;
// //     }

// //     const { headers, rows } = transformPKVYResponseToCsvRowsDynamicCropsWithSeason(allRows);

// //     const csvOptions = {
// //       fieldSeparator: ",",
// //       quoteStrings: '"',
// //       decimalSeparator: ".",
// //       showLabels: true,
// //       useBom: true,
// //       useKeysAsHeaders: false,
// //       headers,
// //     };

// //     const csvExporter = new ExportToCsv(csvOptions);
// //     csvExporter.generateCsv(rows);
// //     return;
// //   } catch (err) {
// //     console.error("Error in PKVY export (scheme 22):", err);
// //     setLoaderFarmer(false);
// //     alert("An error occurred while exporting data.");
// //     return;
// //   }
// //     }

//      if (sessionStorage.getItem("schemeCodeModel") === "22") {
//   try {
//     setLoaderFarmer(true);

//     const baseUrl =
//       process.env.NODE_ENV === "development"
//         ? process.env.REACT_APP_DEV_MODE
//         : process.env.REACT_APP_PRO_MODE;

//     const schemeCode = "22";
//     const userType = sessionStorage.getItem("userTypeCodeModel");

//     // -------------------------------
//     // helper functions
//     // -------------------------------
//     const storedOrZero = (key) => {
//       const v = sessionStorage.getItem(key);
//       return v === null || v === "null" || v === "" ? 0 : Number(v);
//     };

//     const readSelected = (valArr) => {
//       if (Array.isArray(valArr) && valArr.length > 0) {
//         const v = valArr[0];
//         return typeof v === "object" ? Number(v.value ?? 0) : Number(v);
//       }
//       return 0;
//     };

//     // -------------------------------
//     // STATE CODE (single-state allowed)
//     // Precedence:
//     //    userType === 1 → take selected stateValue[0] else stored state
//     //    userType !== 1 → take stored state
//     // -------------------------------
//     let stateCode =
//       userType === "1"
//         ? readSelected(stateValue) || storedOrZero("stateNameModel")
//         : storedOrZero("stateNameModel");

//     stateCode = Number(stateCode);

//     // -------------------------------
//     // OTHER FILTERS (priority: selected → stored)
//     // -------------------------------
//     const districtCode =
//       readSelected(districtValue) || storedOrZero("districtNameModel");

//     const subDistrictCode =
//       readSelected(subdistrictValue) || storedOrZero("subDistrictNameModel");

//     const villageCode =
//       readSelected(villageValue) || storedOrZero("villageModel");

//     const SurveyUserCode =
//       sessionStorage.getItem("userTypeCodeModel") === "5"
//         ? sessionStorage.getItem("userCodeModel")
//         : "0";

//     const orgTypeCode = 1; // for scheme 22, consistent with your logic

//     // -------------------------------
//     // DEBUG LOGS (you can remove later)
//     // -------------------------------
//     console.log("=== PKVY EXPORT DEBUG ===");
//     console.log("stateValue:", stateValue);
//     console.log("storedState:", sessionStorage.getItem("stateNameModel"));
//     console.log("Final stateCode:", stateCode);
//     console.log("districtCode:", districtCode);
//     console.log("subDistrictCode:", subDistrictCode);
//     console.log("villageCode:", villageCode);

//     // -------------------------------
//     // PAGINATION LOOP
//     // -------------------------------
//     let pageNum = 1;
//     const pageSize = 1000;
//     let allRows = [];

//     while (true) {
//       const payload = {
//         schemeCode,
//         orgTypeCode,
//         SurveyUserCode,
//         stateCode,
//         districtCode,
//         subDistrictCode,
//         PageNumber: pageNum,
//         PageSize: pageSize,
//         blockCode: 0,
//         villageCode,
//       };

//       console.log("Sending payload:", payload);

//       const res = await axios.post(
//         `${baseUrl}/api/PKVY/getFarmerDetailsByFilter`,
//         payload
//       );

//       const rows = res?.data?.dataContent || [];
//       const message = res?.data?.message;

//       if (!rows.length || message === "Data Not Found") break;

//       allRows = allRows.concat(rows);

//       if (rows.length < pageSize) break; // last page
//       pageNum += 1;
//     }

//     setLoaderFarmer(false);

//     if (!allRows.length) {
//       alert("No data available to export.");
//       return;
//     }

//     // Transform to dynamic crops CSV
//     const { headers, rows } =
//       transformPKVYResponseToCsvRowsDynamicCropsWithSeason(allRows);

//     const csvExporter = new ExportToCsv({
//       fieldSeparator: ",",
//       quoteStrings: '"',
//       decimalSeparator: ".",
//       showLabels: true,
//       useBom: true,
//       useKeysAsHeaders: false,
//       headers,
//     });

//     csvExporter.generateCsv(rows);
//     return;
//   } catch (err) {
//     console.error("Error in PKVY Export (scheme 22):", err);
//     setLoaderFarmer(false);
//     alert("Something went wrong.");
//     return;
//   }
// }


//     // -----------------------
//     // default non-22 export (unchanged)
//     // -----------------------
//     let allowed = [
//       'schemeName',
//       'stateName',
//       'districtName',
//       'subDistrictName',
//       'villageName',
//       'userName',
//       'sectorName',
//       'subSectorName',
//       'projectStatus',
//       'projectName',
//       'projectStartingDate',
//       'expenditureReportDate',
//       'surveyNumber'
//     ];

//     const result = (farmerData || []).map(obj => {
//       const newObj = {};
//       allowed.forEach(key => {
//         newObj[key] = obj?.[key] ?? "";
//       });
//       return newObj;
//     });

//     if (!result.length) {
//       alert("No data available to export.");
//       return;
//     }

//     const csvOptions = {
//       fieldSeparator: ",",
//       quoteStrings: '"',
//       decimalSeparator: ".",
//       showLabels: true,
//       useBom: true,
//       useKeysAsHeaders: false,
//       headers: allowed,
//     };

//     const csvExporter = new ExportToCsv(csvOptions);
//     csvExporter.generateCsv(result);
//   } catch (error) {
//     console.error("Error in handleExportData:", error);
//     setLoaderFarmer(false);
//     alert("An error occurred while exporting data.");
//   }
// };

   
const handleExportData = () => {

  let headers = [
    "schemeName",
    "stateName",
    "districtName",
    "subDistrictName",
    "villageName",
    "farmerName",
    "mobileNo",
    "finYear",
    "caste",
    "gender",
    "createdDate",
    "farmerType",
    "componentName",
    "seasonName",
    "cropName",
    "yield",
    "AreaCovered(Ha)",
    "TotalArea(Ha)"
  ];

  const result = (farmerData || []).map(obj => {

    const crop = Array.isArray(obj.crops) && obj.crops.length > 0
      ? obj.crops[0]
      : {};

    return {
      schemeName: obj.schemecode === 22 ? "PKVY" : "",
      stateName: obj.stateName || "",
      districtName: obj.districtName || "",
      subDistrictName: obj.subDistrictName || "",
      villageName: obj.villageName || "",
      farmerName: obj.farmerName || "",
      mobileNo: obj.mobileNo || "",

      // ✅ root level finYear
      finYear: obj.finYear || "",

      caste: obj.casteCatCode || "",
      gender: obj.gender || "",

      createdDate: obj.createdOn
        ? new Date(obj.createdOn).toLocaleDateString()
        : "",

      farmerType:
        obj.farmerType === 1 ? "Small and Marginal" : "Other",

      // ✅ from crops array
      componentName: crop.cropName || "",
      seasonName: crop.seasonCode || "",
      cropName: crop.cropName || "",
      yield: crop.yield || "",
      areaCovered_Ha: obj.areaCovered_Ha || "",
      totalAreaInHA: obj.totalAreaInHA || ""
    };
  });

  if (!result.length) {
    alert("No data available to export.");
    return;
  }

  const csvExporter = new ExportToCsv({
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers,
  });

  csvExporter.generateCsv(result);
};

function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    // const handlePrevPage = async () => {
    //     setLoaderFarmer(true);
    //     let result;
    //     setPage(page - 1);
    //     if (sessionStorage.getItem("schemeCodeModel") === "1") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

    //             "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
    //             "orgTypeCode": 1,
    //             "SurveyUserCode": "0",
    //             "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
    //             "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
    //             "subDistrictCode": "0",
    //             "PageNumber": page - 1
    //         })
    //     }
    //    else if (sessionStorage.getItem("schemeCodeModel") === "9") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

    //             "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
    //             "orgTypeCode": 1,
    //             "SurveyUserCode": "0",
    //             "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
    //             "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
    //             "subDistrictCode": "0",
    //             "PageNumber": page - 1,
    //             "PageSize": 1000
    //         })
    //     }
    //     else if (sessionStorage.getItem("schemeCodeModel") === "12") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

    //             "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    //             "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    //             "PageNumber": page - 1
    //         })
    //     }
    //     const data = await result.data.dataContent;
    //     setLoaderFarmer(false);
    //     setfarmerData(data);
    //     setIsFetching(false);
    //     setHasNextPage(true)
    // };

    // const handleNextPage = async () => {
    //     setLoaderFarmer(true);

    //     setPage(page + 1);
    //     let result;
    //     if (sessionStorage.getItem("schemeCodeModel") === "1") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

    //             "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
    //             "orgTypeCode": 1,
    //             "SurveyUserCode": "0",
    //             "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
    //             "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
    //             "subDistrictCode": "0",
    //             "PageNumber": page + 1
    //         })
    //     }
    //     else if (sessionStorage.getItem("schemeCodeModel") === "9") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

    //             "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
    //             "orgTypeCode": 1,
    //             "SurveyUserCode": "0",
    //             "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
    //             "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
    //             "subDistrictCode": "0",
    //             "PageNumber": page + 1,
    //             "PageSize": 1000
    //         })
    //     }
    //     else if (sessionStorage.getItem("schemeCodeModel") === "12") {
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

    //             "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    //             "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
    //             "PageNumber": page + 1
    //         })
    //     }
    //     const data = await result.data.dataContent;
    //     setLoaderFarmer(false);
    //     setfarmerData(data);
    //     if (result.data.message === "Data Not Found") {
    //         setHasNextPage(false)
    //     }
    //     setIsFetching(false);
    // };


    // function handleSurveyNumber(value) {
    //     const valueFinal = value.replace(/\D/g, "");
    //     setSurveyValue(valueFinal)
    // }

    // function handleSurveyorName(value) {
    //     //alert(value);
    //    // const valueFinal = value.replace(/\D/g, "");
    //     setSurveyorNameValue(value)
    //     console.log("value==========",value)
        
    // }



    // const fetchDataFilterWise = async () => {
    //     setLoaderFarmer(true);
    //     setfarmerData([]);
    //     let stateValueData = "0";
    //     let districtValueData = "0";
    //     let subdistrictValueData = "0";
    //     let villageValueData = "0";
        


    //     stateValue.map((item) => {
    //         stateValueData = stateValueData + item + ","
    //     })

    //     stateValueData = stateValueData.slice(0, -1);

    //     if (selectedDataSetDistrict != "") {
    //         const districtParts = selectedDataSetDistrict.split("|");
    //         districtValueData = districtParts[1];
    //     }
    //     if (selectedDataSetSubDistrict != "") {
    //         const SubdistrictParts = selectedDataSetSubDistrict.split("|");
    //         subdistrictValueData = SubdistrictParts[1];
    //     }
    //     if (selectedDataSetVillage != "") {
    //         const VillageDataParts = selectedDataSetVillage.split("|");
    //         villageValueData = VillageDataParts[1];
    //     }
      

    //     let result;

       
    //     if (sessionStorage.getItem("schemeCodeModel") === "22") {
    //         const userType = sessionStorage.getItem("userTypeCodeModel");
    //         const storedState = sessionStorage.getItem("stateNameModel");
    //         const stateCode = userType === "1" ? stateValue[0] ?? 0 : !storedState || storedState === "null"  ? 0  : storedState;
        
    //         setLoaderFarmer(true);
    //         result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/PKVY/getFarmerDetailsByFilter`, {
    //             // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
    //             "schemeCode": sessionStorage.getItem("schemeCodeModel"),
    //             "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
    //             "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
    //             // "stateCode": sessionStorage.getItem("userTypeCodeModel") === "1" ? stateValue[0]?.value  :    sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
    //              stateCode,
    //             "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
    //             "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
    //             "PageNumber": page,
    //             "PageSize": 1000,
    //             // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
    //             "blockCode" : 0,
    //             "villageCode" : villageValue[0] || 0
    //         })
            
    //         // setfarmerData(result.data.dataContent);
    //         //  setIsFetching(false);
    //         const data = await result.data.dataContent;
    //         setfarmerData (data);
    //         setIsFetching(false);
    //         setLoaderFarmer(false);
    //        }

    // };


const fetchDataFilterWise = async () => {
  try {
    setLoaderFarmer(true);
    setfarmerData([]);
    setIsFetching(true);

    // helper: parse stored value or return 0
    const storedOrZero = (key) => {
      const v = sessionStorage.getItem(key);
      return v === null || v === undefined || v === "" || v === "null" ? 0 : v;
    };
    const toNum = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    };

    // ---------- STATE handling ----------
    // If multiple states selected (shouldn't happen for scheme 22), prefer first.
    const selectedStateRaw = Array.isArray(stateValue) && stateValue.length > 0 ? stateValue[0] : null;
    const storedState = storedOrZero("stateNameModel");
    const userType = sessionStorage.getItem("userTypeCodeModel");

    let stateCodeRaw;
    if (userType === "1") {
      stateCodeRaw = selectedStateRaw ?? storedState ?? 0;
    } else {
      stateCodeRaw = storedState ?? selectedStateRaw ?? 0;
    }
    const stateCode = toNum(stateCodeRaw);

    // ---------- DISTRICT / SUBDISTRICT / VILLAGE ----------
    // Priority logic:
    // 1) if selectedDataSetDistrict exists (format stateid|districtCode) use that
    // 2) else if districtValue array has a first item use it
    // 3) else use sessionStorage value
    const getFromSelectedDataSet = (selectedDatasetString) => {
      if (!selectedDatasetString) return 0;
      // selectedDatasetDistrict might be like "stateid|districtCode" or comma-separated multiple
      // we take first segment if comma separated, then split on '|' and take second part.
      const first = String(selectedDatasetString).split(",")[0];
      const parts = first.split("|");
      return parts[1] ?? parts[0] ?? 0;
    };

    let districtCodeRaw = 0;
    if (selectedDataSetDistrict) {
      districtCodeRaw = getFromSelectedDataSet(selectedDataSetDistrict);
    } else if (Array.isArray(districtValue) && districtValue.length > 0) {
      districtCodeRaw = districtValue[0];
    } else {
      districtCodeRaw = storedOrZero("districtNameModel");
    }
    const districtCode = toNum(districtCodeRaw);

    let subdistrictCodeRaw = 0;
    if (selectedDataSetSubDistrict) {
      subdistrictCodeRaw = getFromSelectedDataSet(selectedDataSetSubDistrict);
    } else if (Array.isArray(subdistrictValue) && subdistrictValue.length > 0) {
      subdistrictCodeRaw = subdistrictValue[0];
    } else {
      subdistrictCodeRaw = storedOrZero("subDistrictNameModel");
    }
    const subdistrictCode = toNum(subdistrictCodeRaw);

    let villageCodeRaw = 0;
    if (selectedDataSetVillage) {
      villageCodeRaw = getFromSelectedDataSet(selectedDataSetVillage);
    } else if (Array.isArray(villageValue) && villageValue.length > 0) {
      villageCodeRaw = villageValue[0];
    } else {
      villageCodeRaw = storedOrZero("villageModel");
    }
    const villageCode = toNum(villageCodeRaw);

    // ---------- common payload pieces ----------
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const SurveyUserCode = sessionStorage.getItem("userTypeCodeModel") === "5"
      ? sessionStorage.getItem("userCodeModel")
      : "0";
    const orgTypeCode = schemeCode === "3" ? 0 : 1;

    // debug (optional)
    console.log("fetchDataFilterWise -> stateCode:", stateCode, "districtCode:", districtCode, "subdistrictCode:", subdistrictCode, "villageCode:", villageCode);

    // ---------- SCHEME-based call (22 implemented) ----------
    if (schemeCode === "22") {
      const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;

      const payload = {
        schemeCode,
        orgTypeCode,
        SurveyUserCode,
        stateCode,
        districtCode,
        subDistrictCode: subdistrictCode,
        PageNumber: page,
        PageSize: 1000,
        blockCode: 0,
        villageCode,
      };

      try {
        const result = await axios.post(`${baseUrl}/api/PKVY/getFarmerDetailsByFilter`, payload);
        const data = result?.data?.dataContent ?? [];
        // set data and sessionStorage for persist if needed
        setfarmerData(data);
        sessionStorage.setItem("searchResults", JSON.stringify(data));
        sessionStorage.setItem("searchFilters", JSON.stringify({
          stateValue,
          districtValue,
          subdistrictValue,
          villageValue,
          selectedDataSetDistrict,
          selectedDataSetSubDistrict,
          selectedDataSetVillage
        }));
      } catch (err) {
        console.error("fetchDataFilterWise (scheme 22) error:", err);
        alert("Error fetching data.");
      } finally {
        setIsFetching(false);
        setLoaderFarmer(false);
      }
      return;
    }
else if (schemeCode === "17") {
      const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;

      const payload = {
        schemeCode,
        //orgTypeCode,
        SurveyUserCode,
        stateCode,
        districtCode,
        subDistrictCode: subdistrictCode,
       // PageNumber: page,
       // PageSize: 1000,
        blockCode: 0,
        villageCode,
       // farmerCode: 0,
      };

      try {
        const result = await axios.post(`${baseUrl}/api/MIDH/MIDHFarmerDetails/GetDccdFarmerDetailsAsync`, payload);
        const data = result?.data?.dataContent ?? [];
        // set data and sessionStorage for persist if needed
        setfarmerData(data);
        sessionStorage.setItem("searchResults", JSON.stringify(data));
        sessionStorage.setItem("searchFilters", JSON.stringify({
          stateValue,
          districtValue,
          subdistrictValue,
          villageValue,
          selectedDataSetDistrict,
          selectedDataSetSubDistrict,
          selectedDataSetVillage
        }));
      } catch (err) {
        console.error("fetchDataFilterWise (scheme 22) error:", err);
        alert("Error fetching data.");
      } finally {
        setIsFetching(false);
        setLoaderFarmer(false);
      }
      return;
    }
    // ---------- other schemes (keep your other scheme logic here) ----------
    // e.g. scheme 12, 14, 9 etc.
    // ... your existing branches ...
    setIsFetching(false);
    setLoaderFarmer(false);

  } catch (err) {
    console.error("fetchDataFilterWise error:", err);
    setLoaderFarmer(false);
    setIsFetching(false);
  }
  
};

    

    function ClearSearch(){
        setStateValue([]);
        setOptionDistrict([]);
        setDistrictValue([]);
        setfarmerData([]);
        setselectedDataSetDistrict('');
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setOptionVillage([]);
        setvillageValue([]);
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");
    }

    function ValidateAddUser() {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
    
    if (districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;   
    }
    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }

    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }

    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [

            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1,
                 size: 20,
            },
               // View Details Button Logic
            {
                accessor: '',
                header: 'View Details',
                size: 40,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            },
            {
                accessorKey: 'stateName',
                header: 'State',
                size: 120,
            },
            {
                accessorKey: 'districtName',
                header: 'District',
                size: 120,
            },
             
             {
                accessorKey: 'subDistrictName',
                header: 'Sub District Name',
                size: 120,
            }, 
             {
                accessorKey: 'villageName',
                header: 'Village Name',
                size: 120,
            }, 
            {
                accessorKey: 'farmerName',
                header: 'Farmer Name',
            },
             {
                    accessorKey: 'mobileNo',
                    header: 'Mobile No.',
            },
            {
              accessorKey : "areaCovered_Ha",
              header : "Area Covered (Ha)"
            },
            {
                accessorKey: "totalAreaInHA",
                header : "Total Area (Ha)"
            }   
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);
  


    const userType = sessionStorage.getItem("userTypeCodeModel");
    const isStateLocked = Number(userType) >= 2;
    const isDistrictLocked = Number(userType) >= 3;
    const isSubDistrictLocked = Number(userType) >= 4;
    
    // Lock + auto‑set State for higher user types
    useEffect(() => {
      if (Number(userType) >= 2) {
        const storedState = sessionStorage.getItem("stateCodeModel");
        if (storedState && storedState !== "null") {
          // [stateValue] effect se handleState() chale
          setIsFetchingState(false);
          setStateValue([Number(storedState)]);
        }
      }
    }, [userType]);

    // Lock + auto‑set District for higher user types
    useEffect(() => {
      if (Number(userType) >= 3 && optionDistrict.length) {
        const storedDistrict = sessionStorage.getItem("districtCodeModel");
        if (storedDistrict && storedDistrict !== "null") {
          setDistrictValue([Number(storedDistrict)]);
        }
      }
    }, [userType, optionDistrict]);

    // When district is auto‑set for locked users, trigger sub‑district API once
    useEffect(() => {
      if (
        Number(userType) >= 3 &&
        optionDistrict.length &&
        districtValue.length &&
        !optionSubDistrict.length &&
        !selectedDataSetDistrict // ensure we haven't already triggered
      ) {
        const selectedDistrictOptions = optionDistrict.filter((option) =>
          districtValue.includes(option.value)
        );

        if (selectedDistrictOptions.length) {
          // This will call /api/subdistrict and populate optionSubDistrict
          handleChangeDistrict(selectedDistrictOptions);
        }
      }
    }, [
      userType,
      optionDistrict,
      districtValue,
      optionSubDistrict,
      selectedDataSetDistrict,
    ]);

    return (
      <>
        <section className="section">
          <div className="row surveydetailsBg">
            <div className="col-md-3">
              <label htmlFor="State" className="form-label">
                State
              </label>
              <label style={{ color: "red" }}>*</label>
              <MultiSelect
                options={optionState}
                value={optionState.filter((option) =>
                  stateValue.includes(option.value)
                )}
                // value={selected}
                onChange={Number(userType) >= 2 ? undefined : handleChange}
                labelledBy={"Select"}
                isCreatable={true}
                disabled={Number(userType) >= 2}
                defaultValue={stateValue}
                className={isStateLocked ? "state-multiselect-disabled" : ""}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="District" className="form-label">
                District
              </label>
              <label style={{ color: "red" }}></label>
              <MultiSelect
                options={optionDistrict}
                value={optionDistrict.filter((option) =>
                  districtValue.includes(option.value)
                )}
                onChange={isDistrictLocked ? undefined : handleChangeDistrict}
                labelledBy={"Select"}
                isCreatable={true}
                disabled={isDistrictLocked}
                className={isDistrictLocked ? "state-multiselect-disabled" : ""}
                defaultValue={districtValue}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="SubDistrict" className="form-label">
                Sub District
              </label>
              <label style={{ color: "red" }}></label>
              <MultiSelect
                options={optionSubDistrict}
                value={optionSubDistrict.filter((option) =>
                  subdistrictValue.includes(option.value)
                )}
                // value={selected}
                onChange={handleChangeSubDistrict}
                labelledBy={"Select"}
                isCreatable={true}
                defaultValue={subdistrictValue}
              />
              {/* <MultiSelect
                options={optionSubDistrict}
                value={optionSubDistrict.filter((option) =>
                  subdistrictValue.includes(option.value)
                )}
                onChange={
                  isSubDistrictLocked ? undefined : handleChangeSubDistrict
                }
                labelledBy={"Select"}
                isCreatable={true}
                disabled={isSubDistrictLocked}
                className={
                  isSubDistrictLocked ? "state-multiselect-disabled" : ""
                }
                defaultValue={subdistrictValue}
              /> */}
            </div>
            <div className="col-md-3">
              <label htmlFor="Village" className="form-label">
                Village
              </label>
              <label style={{ color: "red" }}></label>
              <MultiSelect
                options={optionVillage}
                value={optionVillage.filter((option) =>
                  villageValue.includes(option.value)
                )}
                onChange={handleChangeVillage}
                labelledBy={"Select"}
                isCreatable={true}
                defaultValue={villageValue}
              />
            </div>
            <br /> <br />
            <div className="col-md-12 d-flex justify-content-md-center mt-3">
              <button
                type="button"
                className="btn btn-primary farmrbtn me-md-2"
                onClick={ValidateAddUser}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-success me-md-2"
                onClick={ClearSearch}
              >
                Clear
              </button>
            </div>
          </div>

          {errorMessage && (
            <div class="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}

          {LoaderFarmer === false ? (
            ""
          ) : (
            <div class="overlay">
              <div class="overlay__inner">
                <div class="overlay__content">
                  <span class="spinner"></span>
                </div>
              </div>
            </div>
          )}

          {farmerData.length != 0 && (
            <div className="row justify-content-lg-center">
              <div className="col-lg-12 ">
                <div className="card">
                  <MaterialReactTable
                    columns={columns}
                    data={farmerData}
                    // enableColumnOrdering
                    enablePagination={true}
                    state={{ isLoading: isFetching ? true : false }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        {sessionStorage.getItem("schemeCodeModel") === "12" ? (
                          <Button
                            color="primary"
                            // export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={handleExportDataNew}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export in CSV
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            // export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={handleExportData}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export in CSV
                          </Button>
                        )}
                      </Box>
                    )}
                  />
                </div>
              </div>
            </div>
          )}
        </section>
      </>
    );
}

export default PKVYList;
